import IFormService from "./IFormService";
import FormData from "../../dto/Form/FormData";
import FormSaveData from "../../dto/Form/FormSaveData";
import GetUrlPrefix from "../../util/GetUrlPrefix";
import fixEnum from "../../util/FixEnum";
import FormFieldType from "../../dto/Form/FormFieldType";
import CaptchaData from "../../dto/Captcha/CaptchaData";

export default class WebFormService implements IFormService {
    public async getFormData(id: string, token: string): Promise<FormData> {
        let resp = await fetch(`${GetUrlPrefix()}api/form/${id}?token=${encodeURIComponent(token)}`, {
            method: "GET"
        });
        let formData = (await resp.json()) as FormData;
        if(formData.sections) {
            for(let curSection of formData.sections) {
                if(!curSection.fields) {
                    continue;
                }

                for(let curField of curSection.fields) {
                    curField.type = fixEnum(curField.type, FormFieldType);
                }
            }
        }
        return formData;
    }

    public async saveFormData(id: string, token: string, formData: FormSaveData, captchaData: CaptchaData, captchaValue: string): Promise<void> {
        let postData = new URLSearchParams({
            DNTCaptchaInputText: captchaValue,
            DNTCaptchaText: captchaData.dntCaptchaTextValue,
            DNTCaptchaToken: captchaData.dntCaptchaTokenValue
        });
        for(let curFieldData in formData.formFieldValues) {
            postData.append(`f_${curFieldData}`, formData.formFieldValues[curFieldData]);
        }

        let resp = await fetch(`${GetUrlPrefix()}api/form/${id}?token=${encodeURIComponent(token)}`, {
            method: "POST",
            body: postData,
            headers: {
                "Content-Type": "application/x-www-form-urlencoded"
            }
        });
        if(!resp.ok) {
            throw new Error("Error saving form data");
        }
    }
}